import { Subscription } from 'rxjs';
import { Component, Input, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
import { ICON_STATE_MAPPER, ROUTER_STATE_MAPPER, isAgriTenant } from 'src/app/core/config/config.constants';
import { MenuItem } from 'src/app/core/models/menuItem';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { SideNavItem } from './sidenav-item';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidenav-item',
  templateUrl: './sidenav-item.component.html',
  styleUrls: ['./sidenav-item.component.scss']
})
export class SidenavItemComponent implements OnInit, OnDestroy {
  public faGears = faCogs;
  @Input() stylesheetString: string;
  @Input() menuItem: MenuItem;

  // Custom panel properties
  @ViewChild('customMenuTrigger', { read: ElementRef }) customMenuTrigger: ElementRef;
  isCustomPanelOpen = false;
  panelTop = 0;
  panelLeft = 0;

  // getter e non campo readonly: isAgriTenant() legge localStorage['user'], che potrebbe non
  // essere ancora popolato quando il componente viene costruito.
  get newFeatureLabels(): string[] {
    return !isAgriTenant()
      ? ['dashboardHistoricalConsumption', 'home20', 'ucontrolMonitoring']
      : ['consumptionTrend20', 'home20', 'ucontrolMonitoring'];
  }

  get isNewFeature(): boolean {
    return this.newFeatureLabels.includes(this.menuItem?.label);
  }

  dataSource: any;
  routingSubscription: Subscription;

  environment = environment.environmentName;

  constructor(
    private translateService: TranslateService,
    private router: Router
  ) {
    this.routingSubscription = router.events.subscribe((val:any) => {
        // see also
        if(val?.url?.includes('home') || val?.url?.includes('alertreport') || val?.url?.includes('preferences')){
          this.clearSelection(true);
        }
    });
  }

  ngOnInit(): void {
    this.initNavItemStyle();
    this.dataSource = [{ text: this.translateService.instant('home.openInNewTab') }];
  }

  ngOnDestroy(): void {
    this.routingSubscription.unsubscribe();
  }

  subItemClick(subItem: SideNavItem) {
    //console.log(subItem.label);
    let url: string;
    if (this.menuItem.label === 'newCustomDashboardColl' && subItem.label !== 'addNewCustomDashboard') {
      if (subItem.label !== 'addNewCustomDashboard' && subItem.label !== 'adminDashboard')
        url = ROUTER_STATE_MAPPER[this.menuItem.label] + (subItem as any).id;
      else
        url = '/app/dashboards/admin';
    }
    else {
      url = ROUTER_STATE_MAPPER[subItem.label];
    }

    if (!url) {
      console.error('Cannot navigate: URL mapping not found for', subItem.label);
      return;
    }

    // Close custom panel
    this.closeCustomPanel();
    this.navigateToPage(url);
  }

  onSubMenuClose() {
    this.clearSelection(false);
  }

  clearSelection(navigateAction: boolean) {
    let navItemGroup = document.querySelectorAll(".nav-item");
    navItemGroup.forEach((navItem) => {
      if (navItem.classList.contains("item-active")) {
        navItem.classList.remove("item-active");
      }
      if (navigateAction && navItem.classList.contains("item-selected")) {
        navItem.classList.remove("item-selected");
      }
    });
  }

  navigateToPage(url: string) {
    if (!url) {
      console.error('Cannot navigate: URL is undefined for menu item', this.menuItem.label);
      return;
    }
    this.clearSelection(true);
    (document.querySelector(".nav-item.item-" + ((this.menuItem as any).name === 'dashboard'
      ? (this.menuItem as any).cssClass : this.menuItem.label)) as HTMLElement).classList.add("item-selected");
    this.router.navigate([url]);
  }

  itemClicked() {
    this.clearSelection(false);
    //console.log('clickMenuTrigger: ' + this.clickMenuTrigger.menuOpen);
    if (this.menuItem.child.length <= 0) {
      let url = (this.menuItem as any).id === undefined
        ? ROUTER_STATE_MAPPER[this.menuItem.label]
        : ROUTER_STATE_MAPPER['newCustomDashboardColl'] + (this.menuItem as any).id;

      if (!url) {
        console.error('Cannot navigate: URL mapping not found for menu item', this.menuItem.label);
        return;
      }

      this.navigateToPage(url);
      this.isCustomPanelOpen = false;
    } else {
      let menuItemDom = (document.querySelector(".nav-item.item-" + this.menuItem.label) as HTMLElement);
      if (menuItemDom && !menuItemDom.classList.contains("item-selected"))
        menuItemDom.classList.add("item-active");

      // Open custom panel when there are children
      this.openCustomPanel(this.menuItem.child.length);
    }
  }

  initNavItemStyle() {
    let found = false;
    if (this.menuItem.child.length > 0) {
      this.menuItem.child.forEach((elementChild) => {
        if (ROUTER_STATE_MAPPER[elementChild.label] == this.router.url) found = true;
      })
    } else {
      if (ROUTER_STATE_MAPPER[this.menuItem.label] == this.router.url) found = true;
    }
    if (found) {
      setTimeout(() => {
        let menuItemDom = (document.querySelector(".nav-item.item-" + this.menuItem.label) as HTMLElement);
        menuItemDom.classList.add("item-selected");
      }, 50);

    };
  }

  getLabel(label?: string): string {
    if (!label) {
      label = this.menuItem.label ?? (this.menuItem as any).name;
    }
    if (this.menuItem) {
      if ((this.menuItem as any).name !== undefined) { // Label for dashboard at menu level
        return label;
      } else if (this.menuItem.label === 'newCustomDashboardColl'
          && label !== 'newCustomDashboardColl'
          && label !== 'addNewCustomDashboard' && label !== 'adminDashboard') {
        return label;
      }
      else
        return this.translateService.instant('global.menu.' + label);
        // return "global.menu." + label;
    }
    return '';
  }

  getIcon() {
    return (this.menuItem as any)?.name === 'dashboard' ? (this.menuItem as any).icon : ICON_STATE_MAPPER[this.menuItem.label];
      // ICON_STATE_MAPPER[(this.menuItem as any).name ? 'dashboard' : this.menuItem.label];
  }

  getMenuClass() {
    return (this.menuItem as any)?.name === 'dashboard' ? (this.menuItem as any).cssClass : this.menuItem.label;
  }

  getChilds() {
    // Old filtering method based on environment - to be deprecated
    /* let childs: any[] = [];
    this.menuItem.child.forEach(c => {
      const menuEnv = this.environment + '_' + c.label;
      if (c.name !== 'dashboard' && ROUTER_STATE_MAPPER[menuEnv]) {
        childs.push(c);
      } else if (c.name === 'dashboard') {
        childs.push(c);
      }
    }); */

    return (_.orderBy(this.menuItem.child, ['order'], ['asc']) as any);
  }

  itemClick(subItem: any): void {
    let url = ROUTER_STATE_MAPPER[subItem.label];
    window.open('/#/' + url);
  }

  // Old grant check method - to be deprecated
  /* checkFakeGrant(): boolean {
    const menuEnv = this.environment + '_' + this.menuItem.label;
    if (this.menuItem.child.length === 0) {
      if (this.menuItem.name !== 'dashboard' && ROUTER_STATE_MAPPER[menuEnv]) {
        return true;
      } else if (this.menuItem.name === 'dashboard') {
        return true;
      }
      return false;
    }
    else
      return true;
  } */

  checkEnvGrant(subItem?: MenuItem): boolean {
    const menuEnv = subItem ? subItem.env : this.menuItem.env;
    if (!menuEnv)
      return true;
    else {
      const allowedEnvs = menuEnv.split(',');
      if (this.environment && allowedEnvs.indexOf(this.environment) >= 0)
        return true;
    }

    return false;
  }

  openCustomPanel(childLength: number): void {
    if (!this.customMenuTrigger) return;

    const triggerElement = this.customMenuTrigger.nativeElement;
    const triggerRect = triggerElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Estimate panel height (you can adjust this based on your content)
    const estimatedPanelHeight = childLength * 48 > 300 ? 300 : childLength * 48; // Max height 300px
    const offset = 69;

    // Calculate space above and below trigger
    const spaceAbove = triggerRect.top;
    const spaceBelow = viewportHeight - triggerRect.bottom;

    this.panelTop = spaceAbove;
    if (triggerRect.bottom + estimatedPanelHeight > viewportHeight) {
      this.panelTop = Math.max(0, triggerRect.top - estimatedPanelHeight + triggerRect.height);
    }

    /* // Position panel to the right of trigger
    this.panelLeft = triggerRect.right;

    // Determine if panel should open above or below with offset
    if (spaceBelow >= estimatedPanelHeight + offset) {
      // Open below with offset
      this.panelTop = triggerRect.bottom - 77// + offset;
    } else if (spaceAbove >= estimatedPanelHeight + offset) {
      // Open above with offset
      this.panelTop = triggerRect.top - offset - estimatedPanelHeight + 15;
    } else if (spaceBelow > spaceAbove) {
      // Not enough space with offset, open below without full offset
      this.panelTop = triggerRect.bottom + Math.min(offset, spaceBelow - estimatedPanelHeight);
    } else {
      // Not enough space with offset, open above without full offset
      this.panelTop = triggerRect.top - Math.min(offset, spaceAbove - estimatedPanelHeight) - estimatedPanelHeight;
    } */

    this.isCustomPanelOpen = true;
  }

  closeCustomPanel(): void {
    this.isCustomPanelOpen = false;
    this.clearSelection(false);
  }
}
